/**
 * Green Flag — CityPill
 *
 * Small clickable pill labelled "Atlanta" that opens a popover inviting
 * visitors in other cities to reach out via /contact. Atlanta is the only
 * city Green Flag operates in today; this is the explicit affordance
 * surfacing that constraint without dedicating a paragraph to it.
 */

import {
  Box,
  chakra,
  PopoverBody,
  PopoverContent,
  PopoverPositioner,
  PopoverRoot,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { Link as StyledLink } from "../../components/Link/Link";

export const CityPill = () => (
  <PopoverRoot positioning={{ placement: "bottom" }}>
    <PopoverTrigger asChild>
      <chakra.button
        type="button"
        display="inline-flex"
        alignItems="center"
        gap="2"
        bg="whiteAlpha.300"
        color="fg.onBrand"
        borderRadius="full"
        px="5"
        py="2"
        fontSize="md"
        fontWeight="medium"
        cursor="pointer"
        _hover={{ bg: "whiteAlpha.400" }}
      >
        Atlanta
        <Box as="span" fontSize="xs" opacity={0.8}>
          ▾
        </Box>
      </chakra.button>
    </PopoverTrigger>
    <PopoverPositioner>
      <PopoverContent maxW="18rem" bg="white" color="fg.default">
        <PopoverBody>
          <Text mb="2" fontWeight="medium" color="fg.default">
            Interested in another city?
          </Text>
          <Text as="div" fontSize="sm" color="fg.muted">
            Green Flag is only in Atlanta today. If you'd like to see events
            in your city, <StyledLink to="/contact">let us know!</StyledLink>
          </Text>
        </PopoverBody>
      </PopoverContent>
    </PopoverPositioner>
  </PopoverRoot>
);
